// Mirrors apps/admin/src/lib/i18n.ts's init pattern (i18next + react-i18next), scoped to
// this app's single 'quote' namespace. Spanish-only content for launch — adding a language
// later is just a new locale file + one entry in `resources` below, no code changes.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import esQuote from '@/locales/es/quote.json';

export type Locale = 'es';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { quote: esQuote },
    },
    lng: 'es',
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    defaultNS: 'quote',
    ns: ['quote'],
  });

export default i18n;
